var _polygon, _polygon2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "440px",
    height: "330px",
    viewBox: "0 0 440 330",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Graphic elements / Icons / Rich icons / checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Graphic-elements-/-Icons-/-Rich-icons-/-checkmark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "complete-content",
    transform: "translate(76.000000, 36.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(0.000000, 22.000000)",
    fill: "#023852"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "144.21 190.12 132.8 201.52 121.39 212.93 110 224.34 98.6 235.75 73.93 211.1 49.29 186.46 24.65 161.82 0 137.17 11.41 125.77 22.82 114.36 34.23 103 45.63 91.6 58.87 104.83 72.11 118 85.34 131.23 98.58 144.47 134.5 108.55 170.42 72.62 206.34 36.7 242.27 0.8 253.67 12.21 265.08 23.62 276.49 35 287.9 46.41 252 82.35 216.08 118.27 180.16 154.19"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0099DA",
    points: "144.21 190.17 132.8 201.58 121.39 213 110 224.39 98.6 235.8 73.95 211.16 49.31 186.51 24.67 161.87 0 137.23 11.41 125.82 22.82 114.41 34.23 103 45.63 91.6 58.87 104.83 72.11 118.07 85.34 131.3 98.58 144.54 134.5 108.62 170.42 72.7 206.34 36.77 242.27 0.85 253.67 12.26 265.08 23.67 276.49 35.07 287.9 46.48 252 82.4 216.08 118.32 180.16 154.25"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.201f0071557e1e2b7fc50da7208de5fe.svg";
export { ForwardRef as ReactComponent };